import { Injectable } from '@angular/core';
import { Locale } from '@finxone-platform/shared/enums';
import {
  ConfirmationPreferenceTypes,
  DeviceScrollbarVisibility,
  OnboardingConfigFlowTypes,
  PaymentProvider,
  ProjectAuthenticationSettings,
  ProjectConfiguration,
  UISettings,
  defaultAispGocardlessFlowRedirectionConfig,
  defaultAuthoriseFlowConfirmationPreferences,
  defaultConfirmationPreferences,
} from '@finxone-platform/shared/sys-config-types';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetProjectSettings, UpdateProjectSettings } from '../actions/project-settings.action';

export interface ProjectSettingsStateModel {
  onboardingFlow: OnboardingConfigFlowTypes;
  defaultCurrency: string;
  checkPayeeEnabled: boolean;
  smsAuthenticationEnabled: boolean;
  smsAuthenticationExclusion: { [key: string]: string[] };
  enableBeneficiaryFirstAndLastName: boolean;
  locale: string;
  defaultOtherAlerts: boolean;
  uiSettings?: UISettings;
  confirmationPreferenceOrder: ConfirmationPreferenceTypes[];
  //leaving optional atm so we can transition without breaking existing projects, this can be updated once the frontend work is completed for separating authentication settings and we can remove the optional flag and the standalone confirmationPreferenceOrder above
  authentication?: ProjectAuthenticationSettings;
  provider?: PaymentProvider;
  projectConfig?: ProjectConfiguration;
  deviceScrollbarVisibility?: DeviceScrollbarVisibility;
}

@State<ProjectSettingsStateModel>({
  name: 'projectSettings',
  defaults: {
    onboardingFlow: '' as OnboardingConfigFlowTypes,
    defaultCurrency: 'GBP',
    checkPayeeEnabled: true,
    smsAuthenticationEnabled: true,
    smsAuthenticationExclusion: {},
    locale: Locale.en_GB,
    enableBeneficiaryFirstAndLastName: false,
    defaultOtherAlerts: true,
    confirmationPreferenceOrder: defaultConfirmationPreferences,
    authentication: defaultAuthoriseFlowConfirmationPreferences,
    projectConfig: {
      aispFlowRedirectionConfig: defaultAispGocardlessFlowRedirectionConfig,
    } as ProjectConfiguration,
    deviceScrollbarVisibility: { mobile: false, tablet: false, desktop: false },
  },
})
@Injectable()
export class ProjectSettingsState {
  @Selector()
  static getProjectSettings(state: ProjectSettingsStateModel) {
    return state;
  }

  @Selector()
  static getProjectServiceProvider(state: ProjectSettingsStateModel) {
    return state.provider;
  }

  @Action(UpdateProjectSettings)
  updateProjectSettings(ctx: StateContext<ProjectSettingsStateModel>, action: UpdateProjectSettings) {
    ctx.patchState(action.payload);
  }

  @Action(SetProjectSettings)
  setProjectSettings(ctx: StateContext<ProjectSettingsStateModel>, action: SetProjectSettings) {
    ctx.patchState({
      ...ctx.getState(),
      ...action.payload,
    });
  }
}
